import React, { useContext } from "react";
import useDateFormat from "toolkit/useDateFormat";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationScheduledDateLabelField from "module/certification/enrichedComponent/scheduledDateField/CertificationScheduledDateLabelField";

const CertificationScheduledDateFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { formatDate } = useDateFormat();

  const { scheduledDate } = entity as CertificationInterface;

  return (
    <CertificationScheduledDateLabelField {...{ scheduledDate, formatDate }} />
  );
};

export default React.memo(CertificationScheduledDateFieldContainer);
